import { useState } from "react";
import useEvent from "react-use-event-hook";

import { useDropdownItemsCtxProvider } from "@ryde/redux";
import { NO_VALUE_DISPLAY } from "@ryde/shared";

export const useNeighborAreasTemplateSettings = () => {
  const [dayTypesLabels, setDayTypesLabels] = useState(NO_VALUE_DISPLAY);
  const [dayGroupsLabels, setDayGroupsLabels] = useState(NO_VALUE_DISPLAY);
  const [sitesLabels, setSitesLabels] = useState(NO_VALUE_DISPLAY);
  const { getDropdownLabels } = useDropdownItemsCtxProvider();

  const getAndSetDayTypesLabels = useEvent(
    async (dayTypeIds: number[]): Promise<void> => {
      const dropdownDayTypesLabels = await getDropdownLabels(
        "dayType",
        dayTypeIds,
      );
      setDayTypesLabels(dropdownDayTypesLabels.join(", "));
    },
  );

  const getAndSetDayGroupsLabels = useEvent(
    async (dayTypeIds: number[]): Promise<void> => {
      const dropdownDayGroupsLabels = await getDropdownLabels(
        "dayGroup",
        dayTypeIds,
      );
      setDayGroupsLabels(dropdownDayGroupsLabels.join(", "));
    },
  );

  const getAndSetSitesLabels = useEvent(
    async (siteIds: number[]): Promise<void> => {
      const dropdownSitesLabels = await getDropdownLabels("site", siteIds);
      setSitesLabels(dropdownSitesLabels.join(", "));
    },
  );

  return {
    dayTypesLabels,
    dayGroupsLabels,
    sitesLabels,
    getAndSetDayTypesLabels,
    getAndSetDayGroupsLabels,
    getAndSetSitesLabels,
  };
};
